/*
 * Custom JavaScript
 * ===========================================================================
 * Ce fichier est charge en fin de body avec l'attribut defer.
 * ===========================================================================
 */

/* ---------------------------------------------------------------------------
 * Galerie fiche produit premium SEO : rendre les vignettes cliquables.
 * Le markup (.pps-gallery__thumb / [data-pps-thumb]) et le style .is-active
 * existent deja dans la section main-product-premium-seo ; seul le clic
 * manquait, l'image principale restait figee sur le packshot.
 * ------------------------------------------------------------------------ */
(function () {
  function initGallery(section) {
    var main = section.querySelector('.pps-gallery__img');
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-pps-thumb]'));
    if (!main || thumbs.length < 2 || section.dataset.ppsGalleryBound === '1') return;
    section.dataset.ppsGalleryBound = '1';

    function show(btn) {
      var full = btn.getAttribute('data-full');
      if (!full) return;
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t === btn);
        t.setAttribute('aria-current', t === btn ? 'true' : 'false');
      });
      main.classList.add('is-switching');
      var loader = new Image();
      loader.onload = function () {
        var w = btn.getAttribute('data-full-w');
        var h = btn.getAttribute('data-full-h');
        var thumbImg = btn.querySelector('img');
        main.removeAttribute('srcset');
        main.src = full;
        if (w) main.setAttribute('width', w);
        if (h) main.setAttribute('height', h);
        if (thumbImg && thumbImg.alt) main.alt = thumbImg.alt;
        main.classList.remove('is-switching');
      };
      loader.onerror = function () { main.classList.remove('is-switching'); };
      loader.src = full;
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        show(btn);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var next = thumbs[(i + (e.key === 'ArrowRight' ? 1 : thumbs.length - 1)) % thumbs.length];
        next.focus();
        show(next);
      });
    });

    /* Balayage gauche/droite sur l'image principale (mobile). */
    var x0 = null;
    var stage = section.querySelector('.pps-gallery__stage') || main;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) < 40) return;
      var current = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (current < 0) current = 0;
      show(thumbs[(current + (dx < 0 ? 1 : thumbs.length - 1)) % thumbs.length]);
    }, { passive: true });
  }

  document.querySelectorAll('[data-pps-section]').forEach(initGallery);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-pps-section]').forEach(initGallery);
  });
})();
